import actionTypes from "../actionTypes";
import config from "../../config";

export const getUsers = username => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USERS_FETCH,
  url:
    config.api.grantUrl +
    "/users?filters[username][operator]==&filters[username][value]=" +
    username
});

export const getUserById = userId => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USER_FETCH,
  url: config.api.grantUrl + "/users/" + userId
});

export const postUser = (name, email, password) => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USER_POST,
  url: config.api.grantUrl + "/users",
  options: {
    method: "POST",
    body: JSON.stringify({
      username: email,
      password,
      email,
      name
    })
  }
});

export const attachRoleToUser = (userId, roleId) => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USER_FETCH,
  url: config.api.grantUrl + "/roles/" + roleId + "/users/" + userId,
  options: {
    method: "PUT"
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/Users.js